import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Join class names; later Tailwind classes override earlier conflicting ones (e.g. w-32 over w-full). */
export function cn(...args) {
  return twMerge(clsx(...args));
}
